import { Routing } from 'src/pages/routing/routing';

export function MainContent() {
    return <Routing />;
}
